<script>
import Permissions from './Permissions'

export default {
  name: 'PermissionsTenant',
  extends: Permissions,
  computed: {
    users () {
      return this.$store.getters.tenant.users
    }
  },
  methods: {
    addUser (user) {
      if (this.users && this.users.some(item => item.email === user.email)) return alert(this.$t('userAlreadyAdded'))
      return this.dispatchAndToast(this.$store.dispatch('addUserToTenant', user))
    },
    editUser (user) {
      return this.dispatchAndToast(this.$store.dispatch('editUserForTenant', user))
    },
    removeUser (user) {
      if (!confirm(this.$t('confirmRemoveUser'))) return
      return this.dispatchAndToast(this.$store.dispatch('removeUserFromTenant', user))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PermissionsTenant.vue